// src/firebase-init.js (or wherever you prefer to initialize)
import { initializeApp } from 'firebase/app';
import { getMessaging, onMessage } from 'firebase/messaging';
import { firebaseConfig } from '../config/firebase-config';

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

// Check if service workers are supported
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('/firebase-messaging-sw.js')
    .then((registration) => {
      console.log('Service Worker registered with scope:', registration.scope);
      // Set the service worker for FCM
      // This tells FCM where to find your service worker for background messages
      // Call this AFTER getToken()
      // setServiceWorkerRegistration(messaging, registration);
      // Don't call setServiceWorkerRegistration if using the 'messaging/sw' import directly in the SW file.
      // The current approach (importing getMessaging from 'firebase/messaging/sw' in the SW file itself) is generally sufficient.
    })
    .catch((error) => {
      console.error('Service Worker registration failed:', error);
    });
}

onMessage(messaging, (payload) => {
  console.log('Message received. ', payload);
  // Customize notification UI here
  // For example, display a custom toast or a snackbar
  const notificationTitle = payload.notification.title;
  const notificationOptions = {
    body: payload.notification.body,
    icon: '/firebase-logo.png' // Or your app icon
  };

  // Display a notification programmatically if you want
  new Notification(notificationTitle, notificationOptions);

  // Or update your UI directly
  // alert(`New message: ${notificationTitle} - ${notificationOptions.body}`);
});

export { messaging };
